import { formatNumber as formatNumberIt } from './numberFormat';

/** Titolo destinazione senza duplicare nome/cliente quando coincidono o si contengono. */
export function destinazioneHeadline(d) {
  const a = String(d?.nome || d?.nomede || '').trim();
  const b = String(d?.cliente || d?.nome_cliente || d?.ragione_sociale || '').trim();
  if (!a && !b) return 'Destinazione';
  if (!b) return a;
  if (!a) return b;
  if (a === b) return a;
  const al = a.toLowerCase();
  const bl = b.toLowerCase();
  if (al === bl || a.includes(b) || b.includes(a)) return a.length >= b.length ? a : b;
  return `${a} · ${b}`;
}

export function luogoZonaValue(d) {
  return String(d?.luogo_zona ?? d?.luogoZona ?? '').trim();
}

export function indirizzoGpsValue(d) {
  return String(d?.indirizzo_gps ?? d?.indirizzoGps ?? '').trim();
}

export function telefonoDestValue(d) {
  return String(d?.telefono_dest ?? d?.telefonoDest ?? '').trim();
}

export function mapsSearchUrlFromAddress(address) {
  const q = String(address || '').trim();
  if (!q) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function telefonoDialHref(phone) {
  const raw = String(phone || '').trim();
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (raw.trim().startsWith('+')) return `tel:+${digits}`;
  return `tel:${digits}`;
}

export function sortDestinazioniByLuogoZona(list) {
  const arr = Array.isArray(list) ? [...list] : [];
  arr.sort((a, b) => {
    const za = luogoZonaValue(a);
    const zb = luogoZonaValue(b);
    const na = za || '\uffff';
    const nb = zb || '\uffff';
    const c = na.localeCompare(nb, 'it', { numeric: true, sensitivity: 'base' });
    if (c !== 0) return c;
    const ka = `${a?.cod_clie ?? a?.codiceCliente ?? ''}_${a?.cod_dest ?? a?.codiceDestinazione ?? ''}`;
    const kb = `${b?.cod_clie ?? b?.codiceCliente ?? ''}_${b?.cod_dest ?? b?.codiceDestinazione ?? ''}`;
    return String(ka).localeCompare(String(kb), 'it');
  });
  return arr;
}

export function destKeySmistamento(d) {
  return `${d.cod_clie ?? d.codiceCliente ?? ''}_${d.cod_dest ?? d.codiceDestinazione ?? ''}`;
}

export function smistamentoFormatQuantitaCell(value) {
  if (value === null || value === undefined || value === '') return '-';
  const raw = String(value).trim().replace(',', '.');
  const num = parseFloat(raw);
  if (Number.isNaN(num)) return '-';
  if (Number.isInteger(num)) {
    const formatted = formatNumberIt(num, 0);
    return formatted || '-';
  }
  let formatted = formatNumberIt(num, 3);
  if (!formatted) return '-';
  // Virgola decimale IT: 10,500 → 10,5 (non toccare la parte intera, es. 10)
  if (formatted.includes(',')) {
    formatted = formatted.replace(/,0+$/, '').replace(/,$/, '');
  }
  return formatted;
}

/** kg↔Pz come OrderTable (planning). */
export function smistamentoEquivalentePlanning(r) {
  const um = String(r.unita_m ?? r.unita_di_misura ?? r.unitaMisura ?? r.unita ?? '')
    .toLowerCase()
    .trim();
  const quantita = Number(r.quantita ?? r.quantita_totale);
  const peso = Number(
    r.peso ?? r.peso_lo ?? r.data_forn_arti?.peso_lo ?? r.dati_articolo?.peso_lo ?? 0
  );
  if (!Number.isFinite(quantita) || !peso) return '—';
  if (um === 'kg' && Number.isFinite(quantita / peso)) {
    const pz = formatNumberIt(quantita / peso, 0);
    return pz ? `${pz} Pz` : '—';
  }
  if ((um === 'pz' || um === 'n') && quantita * peso !== 0) {
    const kg = formatNumberIt(quantita * peso, 3);
    return kg ? `${kg} kg` : '—';
  }
  return '—';
}

/** Filtro testo su `luogo_zona` (case-insensitive, sottostringa). */
export function filterDestinazioniByLuogoZona(list, filterZonaRaw) {
  const q = String(filterZonaRaw ?? '').trim().toLowerCase();
  if (!q) return Array.isArray(list) ? list : [];
  return (Array.isArray(list) ? list : []).filter((d) =>
    luogoZonaValue(d).toLowerCase().includes(q)
  );
}

/** Data YYYY-MM-DD → etichetta lunga it-IT. */
export function formatGiornoSmistamentoIt(giornoEsatto) {
  const s = String(giornoEsatto || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s || '—';
  const [y, m, d] = s.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  if (Number.isNaN(dt.getTime())) return s;
  return dt.toLocaleDateString('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
